import React from 'react';
import { Paper, Typography, Box, Divider } from '@mui/material';
import articleData from '../data/articles.json';
import { CommentList } from './Comment';

const Article = () => {
  // For this example, we'll use the first article
  const article = articleData.articles[0];

  const renderBulletPoints = (points) => (
    <ul style={{ marginLeft: '20px', marginBottom: '20px' }}>
      {points.map((point, index) => (
        <li key={index}>{point}</li>
      ))}
    </ul>
  );

  const renderSection = (section) => (
    <React.Fragment key={section.title}>
      <Box component="h2" sx={{ fontSize: '1.5rem', mb: 2, mt: 4 }}>
        {section.title}
      </Box>
      
      {section.subsections.map((subsection) => (
        <React.Fragment key={subsection.title}>
          <Box component="h3" sx={{ fontSize: '1.25rem', mb: 2, mt: 3 }}>
            {subsection.title}
          </Box>

          {subsection.topics.map((topic) => (
            <React.Fragment key={topic.title}>
              <Box component="h4" sx={{ fontSize: '1.1rem', mb: 2 }}>
                {topic.title}
              </Box>
              
              {topic.content && <p>{topic.content}</p>}
              {topic.bulletPoints && renderBulletPoints(topic.bulletPoints)}
              {topic.conclusion && <p>{topic.conclusion}</p>}
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
    </React.Fragment>
  );

  return (
    <Paper sx={{ p: 4, mb: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.1)' }}>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom
        sx={{ 
          color: 'primary.main',
          mb: 3
        }}
      >
        {article.title}
      </Typography>
      
      <Box 
        sx={{ 
          display: 'flex', 
          gap: 2, 
          color: 'text.secondary',
          mb: 3
        }}
      >
        <Typography variant="body2">
          By {article.author}
        </Typography>
        <Divider orientation="vertical" flexItem />
        <Typography variant="body2">
          {article.date}
        </Typography>
      </Box>

      <Box
        component="img"
        src={article.image.src}
        alt={article.image.alt}
        sx={{
          width: '100%',
          height: 400,
          objectFit: 'cover',
          borderRadius: 2,
          mb: 4
        }}
      />

      <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.primary' }}>
        <Box component="h2" sx={{ fontSize: '1.5rem', mb: 2, mt: 2 }}>
          {article.content.purpose.title}
        </Box>

        {article.content.purpose.paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}

        {article.content.sections.map((section) => renderSection(section))}
      </Typography>

      <CommentList />
    </Paper>
  );
};

export default Article; 